import TopbarWrap from 'components/TopbarWrap/TopbarWrap';
import AppRouter from 'routers/AppRouter';
import AppFooter from './AppFooter';
import { ScrollTop } from 'primereact/scrolltop';
import userApi from 'api/userApi';
import { useKeycloak } from '@react-keycloak/web';
import React, {  useEffect } from 'react';
import EmptyPage from 'components/EmptyPage/EmptyPage';
import { setAppAuthData, setAuthData, setLogoAuthData } from 'app/slice/authSlice';
import { connect } from 'react-redux';

function DefaultContainer(props) {
    const { keycloak } = useKeycloak();
    const getUserKc = async () => {
        if (keycloak.authenticated) {
            const userResult = await userApi.getUserInfo();
            if (userResult) {
                props.setAuthData(userResult);
            }
        }
    };

    useEffect(() => {
        getUserKc();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        keycloak.onAuthLogout = async function (e) {
            keycloak.login();
        };
        keycloak.onTokenExpired = async function (e) {
            keycloak.login();
        };

        keycloak.onAuthSuccess = async function (e) {
            getUserKc();
        };
        // eslint-disable-next-line
    }, [keycloak]);

    const { initialized } = useKeycloak();

    if (!initialized) {
        return <EmptyPage />;
    }
    return (
        <React.Fragment>
            <TopbarWrap>
                <AppRouter />
                <AppFooter />
                <ScrollTop threshold={200} />
            </TopbarWrap>
        </React.Fragment>
    );
}
function mapStateToProps(state) {
    return { userData: state.auth };
}

const mapDispatchToProps = {
    setAuthData,
    setAppAuthData,
    setLogoAuthData,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultContainer);
